/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const appointmentSlots = sqliteTable('appointment_slots', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  availability_rule_id: text('availability_rule_id'),
  provider_id: text('provider_id'),
  service_id: text('service_id'),
  slot_date: text('slot_date'),
  start_time: text('start_time'),
  end_time: text('end_time'),
  capacity: integer('capacity'),
  slot_type: text('slot_type'),
  status: text('status'),
  source: text('source'),
  notes: text('notes'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  deleted_at: text('deleted_at'),
});
